import './text_input_component.scss'
import { Controller } from 'stimulus'
import { shake } from 'components/validation'

export default class extends Controller {
  static targets = ['input']
  static classes = ['shake']

  shake = (): void => {
    shake(this.inputTarget, this.shakeClass, 500)
  }
}
